export const BASE_API = process.env.REACT_APP_BASE_API;
